// V12.6: captura o IP PÚBLICO real do usuário (no navegador dele) para enviar ao
// backend e repassar ao antifraude do Asaas (remoteIp). Atrás de proxies/ingress o
// IP visto pelo servidor pode ser interno; o IP capturado aqui é o do pagador real.
let _cached = null;
let _inflight = null;

async function _fetchFrom(url, parse) {
  const ctrl = new AbortController();
  const t = setTimeout(() => ctrl.abort(), 3500);
  try {
    const res = await fetch(url, { signal: ctrl.signal });
    if (!res.ok) return null;
    const ip = await parse(res);
    return ip && /^[0-9a-fA-F:.]+$/.test(ip) ? ip.trim() : null;
  } catch {
    return null;
  } finally {
    clearTimeout(t);
  }
}

export async function getClientIp() {
  if (_cached) return _cached;
  if (_inflight) return _inflight;
  _inflight = (async () => {
    let ip = await _fetchFrom("https://api.ipify.org?format=json", (r) => r.json().then((j) => j.ip));
    if (!ip) ip = await _fetchFrom("https://api64.ipify.org?format=json", (r) => r.json().then((j) => j.ip));
    _cached = ip || null;
    _inflight = null;
    return _cached;
  })();
  return _inflight;
}

// Pré-carrega cedo (ex.: ao montar a página) para que o IP já esteja em cache no checkout.
export function warmClientIp() {
  getClientIp().catch(() => {});
}
